import { render } from "./GlobalNsocComponent.vue?vue&type=template&id=099d9d9a&scoped=true"
import script from "./GlobalNsocComponent.vue?vue&type=script&lang=js"
export * from "./GlobalNsocComponent.vue?vue&type=script&lang=js"

import "./GlobalNsocComponent.vue?vue&type=style&index=0&id=099d9d9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099d9d9a"]])

export default __exports__